<script setup lang="ts">
defineProps<{ label: string; col: string; sort: string; order: string }>();
defineEmits<{ sort: [string] }>();
</script>

<template>
  <th class="sortth" @click="$emit('sort', col)">
    {{ label }}
    <span class="arr" :class="{ on: sort === col }">{{ sort === col ? (order === 'asc' ? '↑' : '↓') : '↕' }}</span>
  </th>
</template>

<style scoped>
.sortth {
  text-align: left; color: var(--muted); font-size: 12px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.04em; padding: 8px 12px;
  border-bottom: 1px solid var(--hairline); cursor: pointer; user-select: none; white-space: nowrap;
}
.sortth:hover { color: var(--ink); }
.arr { margin-left: 4px; color: var(--border-input); font-size: 11px; }
.arr.on { color: var(--ink); }
</style>
